import { render, staticRenderFns } from "./RAG.vue?vue&type=template&id=63acb9dd&scoped=true"
import script from "./RAG.vue?vue&type=script&lang=js"
export * from "./RAG.vue?vue&type=script&lang=js"
import style0 from "./RAG.vue?vue&type=style&index=0&id=63acb9dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63acb9dd",
  null
  
)

export default component.exports